var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveBooking
    ? _c(
        "div",
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "booking-duplicate-form",
            {
              attrs: {
                booking: _vm.booking,
                "set-booking-action": _vm.setBooking,
                "set-booking-property-mutator": _vm.setBookingProperty,
              },
            },
            [
              _c("span", { attrs: { slot: "button" }, slot: "button" }, [
                _vm._v("Submit Request"),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Duplicate Booking")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }